import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8l4 8","key":"svg-1"}],["path",{"d":"M10 16l4 -8","key":"svg-2"}]]

const IconCircleLetterX = createReactComponent('outline', 'circle-letter-x', 'CircleLetterX', __iconNode);

export default IconCircleLetterX;